import { isEqual, isObject, transform } from 'lodash';

import i18next from 'i18next';

// Returns RGBA value from 6 character length hex string.

export function hexToRGB(hex: string, alpha: number) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}

export function getInitials(str: string) {
    let names = str.split(' ');

    const ignore = ['FIE', 'OÜ', 'AS', 'TÜ', 'UÜ', 'MTÜ', 'LTD', 'LTD.', 'Ltd', 'Ltd.', '-', '&'];

    names = names.filter((name) => ignore.filter((s) => s === name).length <= 0);

    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

// Comparison

export function objectDiff(baseObject: any, compareWith: any) {
    function changes(object: any, base: any) {
        return transform(object, (result: any, value, key) => {
            if (!isEqual(value, base[key])) {
                result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
            }
        });
    }

    return changes(baseObject, compareWith);
}

// Make first character uppercase

export function toSentenceCase(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// Validate e-mail address syntax

export function validateEmail(email: string) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

// Currency display

export function displaySum(sum: number, currency?: string, options?: object) {
    return sum.toLocaleString(i18next.language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: currency ? currency : 'EUR',
        currencyDisplay: 'symbol',
        ...options,
    });
}

// Generates localed link url

export interface IRouteParams {
    locale: string;
}

export function generateLocaledUrl(params: IRouteParams, to: string, includeHash: boolean = true) {
    let url = '';
    if (params.locale) {
        url = url + '/' + params.locale;
    }
    if (includeHash) {
        url = '#' + url;
    }
    return url + '/' + to;
}

// Returns formatted number

export function formattedNumber(n: number, displayPlus: boolean) {
    let ret = '';
    if (n > 0 && displayPlus) {
        ret = ret + '+';
    }
    ret = ret + n.toFixed(1);
    return ret;
}

// Modal closing handler

export function handleOverlayClosing(
    hash1: string,
    hash2: string,
    overlays: string[],
    closeOverlay: (name?: string, instant?: boolean, noScrollRestore?: boolean) => void,
) {
    if (hash1 !== hash2) {
        const hash = hash1.substr(1);
        const prevHash = hash2.substr(1);
        if (hash && hash !== '') {
            if (overlays.length > 1 && hash && prevHash) {
                const lastOverlay = overlays[overlays.length - 1];
                if (hash !== lastOverlay) {
                    closeOverlay(lastOverlay);
                }
            }
        } else if (overlays.length > 0) {
            closeOverlay('all');
        }
    }
}
